<div class="transaction-details-container">
  <div class="header">
    <div class="header-title">
      <i class="fa-solid fa-satellite-dish header-domain-icon"></i>
      <span class="domain-name">Monitored Domains</span>
    </div>
    <span class="header-subtitle" *ngIf="!isLoading">
      {{ records.length }} subdomain{{ records.length !== 1 ? 's' : '' }} being monitored for certificate changes.
    </span>
    <div class="actions">
      <div class="search-input-container">
        <i class="fa-solid fa-magnifying-glass" style="opacity: 0.9; color: #289DD2;"></i>
        <input type="text" (input)="onSearchChange()" [(ngModel)]="searchQuery" placeholder="Search monitored domains..."
          class="search-input" />
        <i *ngIf="searchQuery" class="fa-solid fa-xmark clear-search"
          style="opacity: 0.8; cursor: pointer; color: #289DD2; margin-left: 5px;"
          (click)="searchQuery = ''; onSearchChange()"></i>
      </div>
    </div>
  </div>

  <div class="table-container">
    <div *ngIf="isLoading" class="no-transactions-message">Loading monitored subdomains...</div>

    <table *ngIf="!isLoading" class="transactions-table">
      <thead>
        <tr>
          <th>
            <div class="th-content">
              <i class="fa-solid fa-globe th-icon"></i>
              <span>Domain</span>
            </div>
          </th>
          <th>
            <div class="th-content">
              <i class="fa-solid fa-clock th-icon"></i>
              <span>Days Remaining</span>
            </div>
          </th>
          <th>
            <div class="th-content">
              <i class="fa-solid fa-shield-halved th-icon"></i>
              <span>Risk Level</span>
            </div>
          </th>
          <th>
            <div class="th-content">
              <i class="fa-solid fa-calendar-check th-icon"></i>
              <span>Last Checked</span>
            </div>
          </th>
          <th>
            <div class="th-content">
              <i class="fa-solid fa-gears th-icon"></i>
              <span>Actions</span>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngIf="filteredRecords.length > 0; else noRecords">
          <tr *ngFor="let item of paginatedRecords; let i = index">
            <td style="font-weight: 500;">
              <i class="fa-solid fa-globe" style="color: #289dd2; margin-right: 8px; font-size: 13px;"></i>
              {{ item.domain || item.commonName }}
            </td>
            <td>
              <span class="days-badge" [ngClass]="getDaysClass(item.notAfter)">
                {{ getDaysRemaining(item.notAfter) < 0 ? 'Expired' : getDaysRemaining(item.notAfter) + 'd' }}
              </span>
            </td>
            <td>
              <span class="risk-badge" [ngClass]="getRiskClass(item.riskLevel)">
                {{ item.riskLevel || 'LOW' }}
              </span>
            </td>
            <td style="opacity: 0.9; font-size: 14px; white-space: nowrap;">
              {{ item.insertedTime | date: 'MMM dd, yyyy – HH:mm' }}
            </td>
            <td>
              <div class="menu-wrapper">
                <button class="action-button dots-button" (click)="toggleMenu(i, $event)" title="Options">
                  <i class="fa-solid fa-ellipsis-vertical"></i>
                </button>
                <div class="dropdown-menu" *ngIf="openMenuIndex === i">
                  <button class="dropdown-item" (click)="openPopup(item); openMenuIndex = null">
                    <i class="fa-solid fa-eye"></i>
                    <span>View details</span>
                  </button>
                  <button class="dropdown-item" [disabled]="refreshInProgress[item.domain || item.commonName]" (click)="refreshMonitoring(item)">
                    <i class="fa-solid fa-rotate"></i>
                    <span>{{ refreshInProgress[item.domain || item.commonName] ? 'Refreshing...' : 'Refresh' }}</span>
                  </button>
                  <button class="dropdown-item danger" [disabled]="stopInProgress[item.domain || item.commonName]" (click)="requestStopMonitoring(item)">
                    <i class="fa-solid fa-circle-stop"></i>
                    <span>{{ stopInProgress[item.domain || item.commonName] ? 'Stopping...' : 'Stop Monitoring' }}</span>
                  </button>
                </div>
              </div>
            </td>
          </tr>
        </ng-container>
        <ng-template #noRecords>
          <tr>
            <td colspan="5" class="no-transactions-message">{{ noRecordsMessage }}</td>
          </tr>
        </ng-template>
      </tbody>
    </table>

    <div class="pagination-container" *ngIf="totalPages > 1">
      <button class="pagination-button" [disabled]="currentPage === 1" (click)="goToPage(currentPage - 1)">
        <i class="fa-solid fa-chevron-left"></i>
      </button>
      <span class="page-info">Page {{ currentPage }} of {{ totalPages }}</span>
      <button class="pagination-button" [disabled]="currentPage === totalPages" (click)="goToPage(currentPage + 1)">
        <i class="fa-solid fa-chevron-right"></i>
      </button>
    </div>
  </div>
</div>

<!-- Certificate Detail Popup -->
<app-certificate-detail-modal [record]="selectedRecord" (closed)="closePopup()"></app-certificate-detail-modal>

<!-- Stop Monitoring Confirmation -->
<div class="confirm-overlay" *ngIf="pendingStopRecord" (click)="cancelStopMonitoring()">
  <div class="confirm-card" (click)="$event.stopPropagation()">
    <div class="confirm-icon">
      <i class="fa-solid fa-triangle-exclamation"></i>
    </div>
    <div class="confirm-title">Stop Monitoring?</div>
    <div class="confirm-message">
      Certificate changes for <strong>{{ pendingStopDomain }}</strong> will no longer be tracked.
      You can start monitoring it again from Domains &gt; View Subdomains.
    </div>
    <div class="confirm-actions">
      <button class="confirm-button cancel" [disabled]="stopInProgress[pendingStopDomain]" (click)="cancelStopMonitoring()">
        Cancel
      </button>
      <button class="confirm-button danger" [disabled]="stopInProgress[pendingStopDomain]" (click)="confirmStopMonitoring()">
        {{ stopInProgress[pendingStopDomain] ? 'Stopping...' : 'Stop Monitoring' }}
      </button>
    </div>
  </div>
</div>
